import { CalendarClock } from "lucide-react";
import { useConsultation } from "@/components/ConsultationProvider";

export default function MobileCtaBar() {
  const { open } = useConsultation();
  return (
    <div
      className="block md:hidden fixed bottom-0 left-0 right-0 z-50 bg-stone-50/95 backdrop-blur-md border-t border-amber-600/30 p-3 shadow-[0_-10px_25px_rgba(0,0,0,0.08)]"
      data-testid="mobile-bottom-consultation-bar"
    >
      <button
        onClick={open}
        data-testid="mobile-bottom-consultation-btn"
        className="w-full bg-amber-600 active:bg-amber-700 text-white font-bold uppercase tracking-wide text-sm py-3.5 rounded-lg shadow-md flex items-center justify-center gap-2 transition-colors duration-200"
      >
        <CalendarClock className="w-5 h-5" />
        Schedule Your In-Home Consultation Today
      </button>
    </div>
  );
}
